import { z } from "zod";

import { zRes401 } from "./common";

import { AdminPanelServicePorts } from "~/entities/admin-panel/model";
import { Response } from "~/shared/api";

const zSchema = AdminPanelServicePorts.ProviderIos.GetOrderStatistics.zOut;

const zRes200 = Response.Schema.zSuccessful(
  200,
  z.object({
    totalOrders: zSchema.shape.ordersToday.shape.value,
    newOrders: zSchema.shape.newOrders.shape.value,
    completedOrders: zSchema.shape.completedOrders.shape.value,
    totalRevenue: zSchema.shape.revenue.shape.value,
    totalOrdersPercentageChange: zSchema.shape.ordersToday.shape.relativeToYesterday,
    newOrdersPercentageChange: zSchema.shape.newOrders.shape.relativeToYesterday,
    completedOrdersPercentageChange: zSchema.shape.completedOrders.shape.relativeToYesterday,
    totalRevenuePercentageChange: zSchema.shape.revenue.shape.relativeToYesterday,
  }),
);

const zRes = Response.Schema.zAggregated([zRes200, zRes401]);
type Res = z.infer<typeof zRes>;

export { zRes };
export type { Res };
